// src/ui/HeroSection.tsx
import React from 'react';

interface HeroProps {
  isMobile: boolean;
  largeur: number;
  setLargeur: (val: number) => void;
  nbCam: number;
}

export const Hero: React.FC<HeroProps> = ({
  isMobile,
  largeur,
  setLargeur,
  nbCam
}) => {
  const emeraldGreen = '#58a08c';
  const darkNavy = '#2c3e50';

  const handleSlider = (val: number) => setLargeur(val);

  return (
    <section
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        padding: '0 10%',
        pointerEvents: 'none',
      }}
    >
      <div style={{ maxWidth: '620px', pointerEvents: 'all' }}>

        {/* Acronym */}
        <h2
          style={{
            fontSize: isMobile ? '1.4rem' : '2rem',
            marginBottom: '0.5rem',
            fontWeight: 600,
            fontFamily: 'Inter, sans-serif',
            color: darkNavy,
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            opacity: 0.75,
          }}
        >
          ViAFaM
        </h2>

        {/* Main Title */}
        <h1
          style={{
            fontSize: 'clamp(1.8rem, 5vw, 3.2rem)',
            margin: 0,
            fontFamily: 'X360, sans-serif',
            letterSpacing: '0.04em',
            lineHeight: 1.2,
            wordWrap: 'break-word',
            color: '#ffffff',
          }}
        >
          <span style={{ color: emeraldGreen, WebkitTextStroke: 'none' }}>Vi</span>
          <span style={{ WebkitTextStroke: '0.01px', WebkitTextStrokeColor: darkNavy }}>Zual</span>
          <span style={{ color: emeraldGreen, WebkitTextStroke: 'none' }}> A</span>
          <span style={{ WebkitTextStroke: '0.01px', WebkitTextStrokeColor: darkNavy }}>utomatic</span>
          <br />
          <span style={{ color: emeraldGreen, WebkitTextStroke: 'none' }}>Fa</span>
          <span style={{ WebkitTextStroke: '0.01px', WebkitTextStrokeColor: darkNavy }}>bric</span>
          <span style={{ color: emeraldGreen, WebkitTextStroke: 'none' }}> M</span>
          <span style={{ WebkitTextStroke: '0.01px', WebkitTextStrokeColor: darkNavy }}>arker</span>
        </h1>

        {/* Subtitle */}
        <p
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: 'clamp(1rem, 4vw, 1.6rem)',
            color: '#555',
            lineHeight: 1.3,
            marginBottom: '1.8rem',
          }}
        >
          Détecteur et marqueur modulaire de défauts de tissu pour machines visiteuses par IA temps réel.
        </p>

        {/* ===== SLIDER ZONE ===== */}
        <div
          style={{
            background: 'rgba(255,255,255,0.9)',
            padding: isMobile ? '20px 15px' : '25px',
            borderRadius: '24px',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
            width: '100%',
            maxWidth: isMobile ? '320px' : '450px',
            pointerEvents: 'all',
          }}
        >
          {/* Badge industrie */}
          <div style={{
            display: 'inline-block',
            padding: '4px 12px',
            background: `${emeraldGreen}15`,
            borderRadius: '100px',
            marginBottom: '15px'
          }}>
            <span style={{
              fontSize: '0.7rem',
              fontWeight: 800,
              color: emeraldGreen,
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Pour Industries Textile & Matières Enroulées
            </span>
          </div>

          {/* Label */}
          <label
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 800,
              fontSize: isMobile ? '0.9rem' : '1rem',
              color: darkNavy,
              display: 'block'
            }}
          >
            Largeur de laize
          </label>

          {/* Valeurs */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              marginTop: '8px',
              fontSize: '1rem',
              color: darkNavy,
            }}
          >
            <span style={{ fontWeight: 900, fontSize: '1.4rem', color: emeraldGreen }}>
              {largeur} <small style={{ fontSize: '0.8rem' }}>cm</small>
            </span>
            <span style={{ fontWeight: 600, opacity: 0.7 }}>
              {nbCam} caméra{nbCam > 1 ? 's' : ''}
            </span>
          </div>

          {/* Slider */}
          <input
            type="range"
            min={60}
            max={360}
            step={10}
            value={largeur}
            onChange={(e) => handleSlider(Number(e.target.value))}
            style={{
              width: '100%',
              height: isMobile ? '12px' : '8px',
              marginTop: '15px',
              accentColor: emeraldGreen,
              cursor: 'pointer'
            }}
          />
        </div>
      </div>
    </section>
  );
};
